import React from 'react';
import './skills.css';
import UIDesign from '../../assets/ui-design.png';
import WebDesign from '../../assets/website-design.png';
import AppDesign from '../../assets/app-design.png';



const Skills = () => {
  return (
    <section id='skills'>
        <span className='skillTitle'>What I Do</span>
        <span className='skillDesc'>I am a computer science professional with sound Knowledge in programming and development. I currently work as an Associate Software Engineer at an MNC. In addition to my technical expertise, I'm passionate about Public Speaking and Video content creation</span>
        <div className='skillBars'>
            <div className='skillBar'>
                 <img src={UIDesign} alt='UIDesign' className='skillBarImg'></img>  
                 <div className='skillBarText'>
                      <h2>Software/Web Developer</h2>
                      <p> I have Made Android Apps like Birthday Wishing, My Calculator,etc. Also made various full stack projects like Result Management System, Library Management System React APPs, etc. </p>
                 </div>
            </div>
            <div className='skillBar'>
                 <img src={WebDesign} alt='WebDesign' className='skillBarImg'></img>  
                 <div className='skillBarText'>
                      <h2>Video Content Creator and Content Writer</h2>
                      <p>My Youtube channel is a platform, where I create and upload Video short films and documentaries on real-life and nostalgic topics, as a hobby.</p>
                 </div>
            </div>
            <div className='skillBar'>
                 <img src={AppDesign} alt='AppDesign' className='skillBarImg'></img>  
                 <div className='skillBarText'>
                      <h2>Public Speaker/Anchor</h2>
                      <p>I have worked as an Anchor and a Public Speaker in various events.</p>
                 </div>
            </div>
        </div> 
    </section>
  );
}

export default Skills;